export default {
  methods: {
    dom_isTouchDevice: () => 'ontouchstart' in window || navigator.msMaxTouchPoints,
  },
};
